import { type ConsentStatusType, type CustomerConsent } from "@repo/api";

export const getConsentStatus = (
  consent?: CustomerConsent
): ConsentStatusType => {
  if (
    consent?.consentId !== undefined &&
    consent?.consentProvided === undefined &&
    consent?.customerCommunicationSendStatus !== "ERROR"
  ) {
    return "PENDING";
  }
  if (consent?.consentProvided === true) {
    return "APPROVED";
  }
  if (consent?.consentProvided === false) {
    return "NOT_APPROVED";
  }
  if (consent?.customerCommunicationSendStatus === "ERROR") {
    return "ERROR";
  }
  return "MISSING";
};
